<template>
    <div class="mb-4">
        <div class="surface mb-2">
            <h1 class="is-size-5 has-text-centered">
                {{ group.descricao }}
            </h1>
        </div>
        <div>
            <question-component
                v-for="question in group.formPerguntaList"
                :key="question.id"
                :question="question"
                :isFinalizado="isFinalizado"
            />
        </div>
    </div>
</template>

<script>
import QuestionComponent from "@/components/shared/QuestionComponent.vue";

export default {
    components: {
        QuestionComponent,
    },
    props: {
        group: {
            type: Object,
            default: () => {},
        },
        isFinalizado: {
            type: Boolean,
            default: false,
        }
    },
};
</script>

<style lang="scss" scoped>
.is-size-5 {
    color: $sovis-white;
}
</style>
